import { Check } from 'lucide-react';
import { Fragment } from 'react/jsx-runtime';
import { Link } from 'react-router-dom';
const DigitalLeader = () => {
  const knowledgeAreas = [
    {
      left: 'Digital transformation with Google Cloud',
      right: 'Exploring data transformation with Google Cloud'
    },
    {
      left: 'Innovating with Google Cloud artificial intelligence',
      right: 'Modernizing infrastructure and applications with Google Cloud'
    },
    {
      left: 'Trust and security with Google Cloud',
      right: 'Scaling with Google Cloud operations'
    }
  ];
  return (
    <div className='mx-auto max-w-7xl rounded-b-2xl px-6 py-12'>
      <div className='mx-auto max-w-4xl px-6 pb-12 pt-4'>
        {/* Title */}
        <h3 className='mb-8 text-2xl font-bold text-gray-900 md:text-3xl'>
          Cloud Digital Leader
        </h3>

        {/* Description Paragraphs */}
        <div className='mb-8 space-y-6 text-gray-700'>
          <p className='text-base leading-relaxed'>
            A Cloud Digital Leader can articulate the capabilities of Google
            Cloud core products and services and how they benefit organizations.
            They can also describe common business use cases and how cloud
            solutions support an enterprise.
          </p>

          <p className='text-base leading-relaxed'>
            This certification is for anyone who wishes to demonstrate their
            knowledge of cloud computing basics and how Google Cloud products
            and services can be used to achieve an organization&apos;s goals.
          </p>

          <p className='text-base leading-relaxed'>
            The Cloud Digital Leader exam assesses your knowledge in these
            areas:
          </p>
        </div>

        {/* Knowledge Areas - Two Column Grid */}
        <div className='mb-10'>
          <div className='grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-2'>
            {knowledgeAreas.map((area, index) => (
              <Fragment key={area.left}>
                {/* Left Column Item */}
                <div className='flex items-start gap-3'>
                  <Check className='mt-0.5 h-5 w-5 flex-shrink-0 text-green-600' />
                  <span className='text-gray-700'>{area.left}</span>
                </div>

                {/* Right Column Item */}
                <div className='flex items-start gap-3'>
                  <Check className='mt-0.5 h-5 w-5 flex-shrink-0 text-green-600' />
                  <span className='text-gray-700'>{area.right}</span>
                </div>
              </Fragment>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className='flex flex-wrap gap-4'>
          <Link
            target='_blank'
            to='https://support.google.com/cloud-certification/#topic=9433215'
            className='rounded border-2 border-blue-600 px-8 py-3 font-medium text-blue-600 transition-colors hover:bg-blue-50'
          >
            View FAQs
          </Link>
        </div>
      </div>

      {/* Header */}
      <h3 className='mb-8 text-center text-3xl font-bold text-gray-900'>
        About this certification
      </h3>

      {/* Introductory Text */}
      <div className='mx-auto mb-12 max-w-5xl space-y-4 text-gray-900'>
        <p className='text-base leading-relaxed'>
          If this is your first time getting certified, or your certification
          has expired, you must take the standard exam.
        </p>
        <p className='text-base leading-relaxed'>
          If you are renewing your certification, you can choose to take the
          shorter renewal exam or the standard exam starting 180 days before
          your expiration date. Once you have chosen either the standard or
          renewal exam path, you will stay in that path until you pass or your
          certification expires.
        </p>
      </div>

      {/* Two Column Layout */}
      <div className='mx-auto grid max-w-6xl grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12'>
        {/* Standard Exam Information */}
        <div>
          <h2 className='mb-6 text-xl font-semibold text-gray-900'>
            Standard exam information
          </h2>

          <div className='space-y-4'>
            <div>
              <span className='font-semibold text-gray-900'>Length:</span>
              <span className='text-gray-900'> 90 minutes</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Content:</span>
              <span className='text-gray-900'> </span>
              <a
                href='#'
                className='text-blue-600 hover:text-blue-800 hover:underline'
              >
                Standard exam guide
              </a>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Registration fee:
              </span>
              <span className='text-gray-900'>
                {' '}
                $99 (plus tax where applicable)
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Language:</span>
              <span className='text-gray-900'>
                {' '}
                English, Japanese, Spanish, Portuguese, French
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Exam format:</span>
              <span className='text-gray-900'>
                {' '}
                50-60 multiple choice questions
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Exam Delivery Method:
              </span>
              <span className='text-gray-900'>
                {' '}
                Online-proctored or onsite-proctored
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Validity period:
              </span>
              <span className='text-gray-900'> 3 years</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Prerequisites:
              </span>
              <span className='text-gray-900'> None</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Recommended experience:
              </span>
              <span className='text-gray-900'>
                {' '}
                Experience collaborating with technical professionals
              </span>
            </div>
          </div>
        </div>

        {/* Renewal Exam Information */}
        <div>
          <h2 className='mb-6 text-xl font-semibold text-gray-900'>
            Renewal exam information
          </h2>

          <div className='space-y-4'>
            <div>
              <span className='font-semibold text-gray-900'>Length:</span>
              <span className='text-gray-900'> 45 minutes</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Content:</span>
              <span className='text-gray-900'> Same as the standard exam</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Registration fee:
              </span>
              <span className='text-gray-900'>
                {' '}
                $60 (plus tax where applicable)
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Languages:</span>
              <span className='text-gray-900'> English, Japanese</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Exam format:</span>
              <span className='text-gray-900'>
                {' '}
                20 multiple choice questions
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Exam Delivery Method:
              </span>
              <span className='text-gray-900'>
                {' '}
                Online-proctored or onsite-proctored
              </span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>
                Validity period:
              </span>
              <span className='text-gray-900'> 3 years</span>
            </div>

            <div>
              <span className='font-semibold text-gray-900'>Eligibility:</span>
              <span className='text-gray-900'>
                {' '}
                Candidates must have an active certification and be within the
                renewal eligibility period.
              </span>
            </div>

            <div className='pt-4'>
              <Link
                target='_blank'
                to='https://support.google.com/cloud-certification/answer/9907853?sjid=10159424711448208692-NC'
                className='rounded border-2 border-blue-600 px-6 py-2.5 font-medium text-blue-600 transition-colors hover:bg-blue-50'
              >
                Renewal FAQs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalLeader;
